<template>
    <v-dialog
        :value="isOpen"
        max-width="650px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Materiał - <strong>{{ materialReservation.materialName }}</strong>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            :value="formatDate(materialReservation.createdAt, false)"
                            label="Data utworzenia"
                            outlined
                            dense
                            readonly
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            :value="materialReservation.amountWithUOM"
                            label="Ilość"
                            outlined
                            dense
                            readonly
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            :value="materialReservation.xlAmountWithUOM"
                            label="Ilość wysłana do XL"
                            outlined
                            dense
                            readonly
                            hide-details
                        />
                    </v-col>
                    <v-col v-if="hasMaterialReservationItems" cols="12">
                        <v-simple-table>
                            <template #default>
                                <thead>
                                    <tr>
                                        <th class="text-center">
                                            Lp.
                                        </th>
                                        <th class="text-center">
                                            Numer zamówienia / zlecenia
                                        </th>
                                        <th class="text-center">
                                            Nazwa produktu
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item, index) in filteredMaterialReservationItems"
                                        :key="index"
                                    >
                                        <td class="text-center">
                                            {{ index + 1 }}
                                        </td>
                                        <td class="text-center">
                                            {{ item.number }}
                                        </td>
                                        <td class="text-center">
                                            {{ parseEmptyValue(item.productName) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse'

export default {
    name: 'MaterialReservationDialog',
    mixins: [ 
        dateFormatter,
        parse,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        materialReservation: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        hasMaterialReservationItems() {
            return this.materialReservation.reservationItems?.length > 0
        },
        filteredMaterialReservationItems() {
            if (this.hasMaterialReservationItems) {
                const items = this.materialReservation.reservationItems.map(item => ({
                    number: item.number,
                    productName: item.productName,
                }))

                return items
            }
            
            return []
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>
